import { mapActions, mapGetters, mapState } from "vuex";

const onboardingStepNavigation = {
    computed: {
        ...mapState("onboarding", [
            "onboardingFlow",
            "completedSteps",
            "selections",
            "onboardingDraft",
            "stepperUi",
            "requestNextToken"
        ]),
        ...mapGetters("onboarding", [
            "routeForStep",
            "completionRoute",
            "reachableSteps",
            "orderedSteps",
            "isStepLocked",
            "isStepCompleted",
            "previewCatalog"
        ]),
        readOnly() {
            return this.stepKey ? this.isStepLocked(this.stepKey) : false;
        }
    },

    // El watcher de requestNextToken es lo que le permite al layout
    // (dueño del botón "Siguiente") disparar el avance de la página activa
    // sin que sean padre/hijo directos: el layout hace
    // dispatch("onboarding/requestNext") y cada página reacciona ejecutando
    // su propio stepperNext(). localStepperUi es el canal inverso: cada
    // página expone un computed con ese nombre y el layout lo refleja.
    watch: {
        requestNextToken() {
            if (typeof this.stepperNext === "function") {
                this.stepperNext();
            }
        },
        localStepperUi: {
            immediate: true,
            deep: true,
            handler(value) {
                if (value) {
                    this.setStepperUi(value);
                }
            }
        }
    },

    methods: {
        ...mapActions("onboarding", [
            "getOnboardingStatus",
            "requestNext",
            "setStepperUi",
            "hydrateOnboardingDraft"
        ]),

        async ensureOnboardingStatus() {
            // Siempre refresca, sin importar si ya hay selections de otros
            // steps: los submits de cada step (submitSocialNetworks, etc.)
            // solo actualizan onboardingFlow, no selections, así que saltarse
            // este fetch dejaba datos viejos al volver a revisar un step ya
            // guardado (ej. redes sociales aparecía vacío).
            try {
                await this.getOnboardingStatus();
            } catch {
                // Keep local state if status endpoint is unavailable
            }
            // HYDRATE_DRAFT solo llena el draft si todavia esta vacio, asi
            // que es seguro llamarlo en cada entrada a un step.
            this.hydrateOnboardingDraft();
        },

        goToStep(step) {
            if (step === this.stepKey) return;
            if (!this.reachableSteps.includes(step)) return;
            const route = this.routeForStep(step);
            if (route) {
                this.$router.push({ path: route, query: { review: "1" } });
            }
        },

        goBack() {
            const previous = this.findReachableStep(-1);
            if (previous) {
                this.goToStep(previous);
            }
            // Sin fallback a otra ruta: en el primer step no hay a dónde
            // volver, y el stepper ya oculta el botón "Atrás" en ese caso.
        },

        goToNextReachable() {
            const next = this.findReachableStep(1);
            if (next) {
                this.goToStep(next);
            }
        },

        findReachableStep(direction) {
            const steps = this.orderedSteps;
            const index = steps.indexOf(this.stepKey);
            if (index === -1) return null;
            for (
                let i = index + direction;
                i >= 0 && i < steps.length;
                i += direction
            ) {
                if (this.reachableSteps.includes(steps[i])) {
                    return steps[i];
                }
            }
            return null;
        }
    }
};

export default onboardingStepNavigation;
